import { bindActionCreators } from 'redux';
import idx from 'idx';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import partial from 'lodash/partial';
import { deleteEntry, toggleEntryDelete, getProjectEntriesState,
  getEntry } from 'project/ducks/entries';
import { getProjectIdFromUrl } from 'project/utils';
import Confirmation from 'common/components/modal/confirmation_dialog';

export function mapStateToProps(state) {
  const userId = idx(state, _ => _.user.profile_data.id);
  const entryId = getProjectEntriesState(state).currentSelectedEntry;
  const entry = getEntry(state, entryId);

  if (!entry) {
    return {};
  }

  const isAuthor = entry.author === userId;
  const headerAction = isAuthor ? 'withdraw' : 'eliminate';

  return {
    dialogHeader: `${headerAction} Entry`,
    dialogTitle: `Are you sure you want to ${headerAction} this entry?`,
    dialogMessage: 'You can add it back to the project later.',
    dialogVisible: idx(state, _ => _.project.projectPage.entries.showDeleteModal),
    primaryActionText: `Yes, ${headerAction}`,
    secondaryActionText: 'Cancel'
  };
}

export function mapDispatchToProps(dispatch, { params }) {
  const projectId = getProjectIdFromUrl(params);

  return bindActionCreators({
    toggleDialog: partial(toggleEntryDelete, null),
    submitAction: partial(deleteEntry, projectId),
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Confirmation));



// WEBPACK FOOTER //
// ./project/containers/entries/delete.js